
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';

import { MapCommand, getLayerById } from '../map';

export default class MapCommandAddPins extends MapCommand {

    constructor(options) {
        super(options);
        this._name = 'SEARCH_ADD_PINS';
    }

    execute(olMap, params) {
        let layer = getLayerById(olMap.getMap(), 'search_pins');
        if (layer) {
            let source = layer.getSource();
            source.clear();

            params.items.forEach(item => {
                let feature = new Feature({
                    geometry: new Point([item.x, item.y])
                });
                if (item._attrs) {
                    feature.setProperties({
                        ...item._attrs,
                        _geom: item.geom,
                        _info: item._info,
                        _title: item.title
                    });
                }
                if (item._layerId) {
                    feature.layerIdData = item._layerId;
                } else if (item._info) {
                    feature.layerIdData = `search:${item._queryId || 'result'}`;
                }
                source.addFeature(feature);
            });
        }
    }
}
